import React from 'react'

const Explorecontent = ({post}) => {
    return (
      
          
           <div className="explore-photo">
             <img src={post.photoUrl} alt="explore"/>
           </div>
         
           
   
    )
}

export default Explorecontent;